export const AUDITS = "AUDITS";
export const BUSY_AUDIT = "BUSY_AUDIT";
export const AUDIT_COUNT = "AUDIT_COUNT";
